import { useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { Pencil } from 'lucide-react';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/Card.tsx';
import NoItems from '@/components/ui/NoItems.tsx';
import { TourInstallmentInputForm } from '@/features/dashboard/tourConfig/schemas/tourInstallmentsSchema.ts';
import { PaymentMethod } from '@/features/dashboard/tourConfig/types/PaymentMethod.ts';
import useGetCashInstruction from '@/features/dashboard/paymentConfig/hooks/useGetCashInstruction.ts';
import EditCashInstructionModal from '@/features/dashboard/paymentConfig/components/EditCashInstructionModal.tsx';
import RichTextPreview from '@/components/richText/RichTextPreview.tsx';

const CashInstructionCard = () => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const { control } = useFormContext<TourInstallmentInputForm>();

  const installments = useWatch({ control, name: 'installments' });

  const hasAnyCash = (installments ?? []).some((inst) =>
    inst.paymentMethods?.includes(PaymentMethod.CASH),
  );

  const { data } = useGetCashInstruction();

  if (!hasAnyCash) return null;

  const hasInstruction = !!data?.instruction;

  return (
    <>
      <Card>
        <CardHeader className="flex flex-row items-center justify-between border-b">
          <CardTitle>Instrukcja płatności gotówką</CardTitle>
          <ActionButton
            tone="outline"
            size="xs"
            onClick={() => setIsEditModalOpen(true)}
          >
            <Pencil />
            Edytuj
          </ActionButton>
        </CardHeader>
        <CardContent>
          {hasInstruction ? (
            <RichTextPreview html={data.instruction} />
          ) : (
            <NoItems
              title="Brak instrukcji"
              description="Dodaj instrukcję płatności gotówką, która będzie widoczna dla uczestników."
              className="mx-auto items-center text-center"
            />
          )}
        </CardContent>
      </Card>
      {isEditModalOpen && (
        <EditCashInstructionModal
          currentInstruction={data?.instruction ?? ''}
          onClose={() => setIsEditModalOpen(false)}
        />
      )}
    </>
  );
};

export default CashInstructionCard;
